import css from './card.module.scss'
export const Card = ({ heading, description, otherText, price, className = '', normalHeading, children}) => {
    return (
        <div className={`${css.card} ${className}`}>
            <h3 className={`${css.heading} ${normalHeading ? css.normalHeading : ''}`}>{heading}</h3>
            {description && <p>{description}</p>}
            {otherText && <div className={css.smallText}>{otherText}</div>}
            {price && <div className={css.price}>{price}</div>}
            {children}
        </div>
    )
}